var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceRangeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 15,
    viewBox: "0 0 31 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7071 8.07112C31.0976 7.6806 31.0976 7.04743 30.7071 6.65691L24.3431 0.292946C23.9526 -0.0975784 23.3195 -0.0975784 22.9289 0.292946C22.5384 0.68347 22.5384 1.31664 22.9289 1.70716L28.5858 7.36401L22.9289 13.0209C22.5384 13.4114 22.5384 14.0446 22.9289 14.4351C23.3195 14.8256 23.9526 14.8256 24.3431 14.4351L30.7071 8.07112ZM0 7.36401V8.36401H30V7.36401V6.36401H0V7.36401Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceRangeArrow);
export default __webpack_public_path__ + "static/media/price_range_arrow.157a652dbf328e5ed91db4f81af631b9.svg";
export { ForwardRef as ReactComponent };